module.exports = __webpack_public_path__ + "static/media/sort-black.f94dfe67.svg";